<template>
  <!-- The buttons come from the parent (slot), so each page keeps its own
       button styles; this component owns the formats and the download. -->
  <v-menu location="bottom end">
    <template #activator="{ props }">
      <slot :menu-props="props" :download="download" />
    </template>
    <v-list density="compact" max-width="340" class="qr-download-menu">
      <v-list-item
        v-for="format in formats"
        :key="format.id"
        lines="two"
        @click="download(format.id)"
      >
        <v-list-item-title class="qr-download-menu__label">{{
          format.label
        }}</v-list-item-title>
        <v-list-item-subtitle class="qr-download-menu__hint">{{
          format.hint
        }}</v-list-item-subtitle>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { downloadQrCodeOfLink } from "../api";
import { QR_FORMATS } from "../qrCode";

export default {
  name: "QrDownloadMenu",
  props: {
    fullUrl: { type: String, default: "" },
  },
  data() {
    return { formats: QR_FORMATS };
  },
  methods: {
    download(format = "png-large") {
      if (!this.fullUrl) {
        window.alert("QR code not available.");
        return;
      }
      // downloadQrCodeOfLink already logs the error
      downloadQrCodeOfLink(this.fullUrl, format).catch(() =>
        window.alert("Error downloading QR code"),
      );
    },
  },
};
</script>

<style scoped>
.qr-download-menu__label {
  font-weight: 600;
}

/* the hints are full sentences: let them wrap instead of truncating */
.qr-download-menu__hint {
  white-space: normal;
  -webkit-line-clamp: unset;
}
</style>
